import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ActionEventArgs,
  EditService,
  EditSettingsModel,
  ExcelExportService,
  FilterService,
  FilterSettingsModel,
  GridComponent,
  GroupService,
  LoadingIndicatorModel,
  PageService,
  PageSettingsModel,
  ReorderService,
  SortService,
  ToolbarItems,
  ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import { first } from 'rxjs';
import { Status } from 'src/app/core/backend/pn/models';
import { TaskVm } from 'src/app/core/backend/tm/models';
import { TaskService } from 'src/app/core/backend/tm/services';
import { AuthenticationService } from 'src/app/core/services/auth.service';

export const defaultFilterType = 'Excel';

@Component({
  selector: 'mg-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss'],
  providers: [
    GroupService,
    SortService,
    ReorderService,
    EditService,
    FilterService,
    PageService,
    ToolbarService,
    ExcelExportService,
  ],
})
export class TasksComponent implements AfterViewInit {
  filterSettings: FilterSettingsModel = { type: defaultFilterType };
  pagesSettings: PageSettingsModel = {
    pageSize: 10,
  };
  selectedStatus: number | null = null;
  filterStatus: Status[] | null | undefined = [];
  public toolbar?: ToolbarItems[] = ['Search', 'Add', 'ExcelExport'];
  editSettings: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: false,
    mode: 'Normal',
  };

  @ViewChild('mg_grid')
  public grid: GridComponent;

  actionBegin(args: ActionEventArgs): void {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.router.navigate(['add'], {
        relativeTo: this.route,
      });
    }

    if (args.requestType === 'beginEdit' && args.primaryKeyValue![0]) {
      args.cancel = true;
      this.router.navigate([args.primaryKeyValue![0], 'edit'], {
        relativeTo: this.route,
      });
    }
  }
  rowSelected(args) {
    args.cancel = true;
    if (args.data.id) {
      this.router.navigate([args.data.id], {
        relativeTo: this.route,
      });
    }
  }

  getAllStatus() {
    // this.taskService.apiTaskManagerTasksGetAllStatusGet().subscribe({
    //   next: (res) => {
    //     this.filterStatus = res.status;
    //     this.selectedStatus = this.selectedStatus;
    //     this.cd.detectChanges();
    //   }
    // })
  }
  toolbarClick(args: any): void {
    if (args?.item?.properties?.id?.includes('excelexpor')) {
      (this.grid as GridComponent).excelExport();
    }
  }
  loadingIndicator: LoadingIndicatorModel = { indicatorType: 'Spinner' };
  gettingData = false;
  constructor(
    private taskService: TaskService,
    private auth: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
  ) {
    this.getAllStatus();
  }

  selectStatus(status: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        status: status,
      },
    });
  }

  ngAfterViewInit(): void {
    this.auth
      .identity()
      .pipe(first())
      .subscribe({
        next: (res) => {
          if (
            !(
              res?.profession_Id == 1 ||
              res?.profession_Id == 2 ||
              res?.profession_Id == 5 ||
              res?.profession_Id == 6 ||
              res?.profession_Id == 7
            )
          ) {
            this.toolbar = ['Search', 'ExcelExport'];
            this.editSettings = {
              allowEditing: true,
              allowAdding: false,
              allowDeleting: false,
              mode: 'Normal',
            };
          }
        },
      });
    this.route.queryParams.subscribe((res) => {
      if (res['status']) {
        this.getTasks(1, res['status']);
        this.selectedStatus = +res['status'];
      } else {
        this.getTasks(1);
      }
    });
  }

  _page = 1;

  allTasks: TaskVm[] | undefined = undefined;
  getTasks(page: number, status?: string) {
    this._page = page;
    this.gettingData = true;
    this.taskService
      .apiTaskGetTasksGet({
        PageSize: 999999999,
        PageNumber: 1,
        // Status: status ? +status : undefined
      })
      .subscribe({
        next: (res) => {
          this.gettingData = false;
          this.allTasks = res.tasks?.items || [];
        },
        error: () => {
          this.gettingData = false;
        },
      });
  }
}
